module.exports = __webpack_public_path__ + "static/img/5.142c3e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/eng/5.png
// module id = csgC
// module chunks = 0